import React, { useState } from 'react';
import PriceTag from './ui/PriceTag';
import './AddonCategory.css';

const defaultCurrency = { code: 'USD', symbol: '$', position: 'before' };
/**
 * Reusable addon category: collapsible section with checkboxes (allowMultiple) or radio (single).
 * Props: category { id, categoryName, isRequired, allowMultiple, options }, onSelect(selectedOptions), selectedOptions [], currency
 */
const AddonCategory = ({ category, onSelect, selectedOptions = [], currency = defaultCurrency }) => {
  const [expanded, setExpanded] = useState(true);

  const selectedIds = Array.isArray(selectedOptions) ? selectedOptions.map(o => o.id) : [];

  const handleOptionChange = (option, checked) => {
    if (category.allowMultiple) {
      if (checked) {
        onSelect([...selectedOptions.filter(o => o.id !== option.id), { id: option.id, name: option.name, price: option.price, category: category.categoryName }]);
      } else {
        onSelect(selectedOptions.filter(o => o.id !== option.id));
      }
    } else {
      if (checked) {
        onSelect([{ id: option.id, name: option.name, price: option.price, category: category.categoryName }]);
      } else {
        onSelect([]);
      }
    }
  };

  const toggleOption = (option) => {
    const isSelected = selectedIds.includes(option.id);
    if (category.allowMultiple) {
      handleOptionChange(option, !isSelected);
    } else {
      handleOptionChange(option, !isSelected);
    }
  };

  return (
    <div className="addon-category">
      <button
        type="button"
        className="addon-category-header"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        <span className="addon-category-name">
          {category.categoryName}
          {category.isRequired && <span className="addon-required-badge">Required</span>}
        </span>
        <span className={`addon-category-chevron ${expanded ? 'expanded' : ''}`}>›</span>
      </button>
      {expanded && (
        <div className="addon-category-options">
          {category.options && category.options.map((option) => {
            const isSelected = selectedIds.includes(option.id);
            return (
              <label key={option.id} className={`addon-option-row ${isSelected ? 'selected' : ''}`}>
                {category.allowMultiple ? (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => handleOptionChange(option, e.target.checked)}
                    className="addon-option-input"
                  />
                ) : (
                  <input
                    type="radio"
                    name={`addon-${category.id}`}
                    checked={isSelected}
                    onChange={() => toggleOption(option)}
                    className="addon-option-input"
                  />
                )}
                <span className="addon-option-name">{option.name}</span>
                <span className={`addon-option-price ${option.price === 0 ? 'free' : ''}`}>
                  {option.price === 0 ? (
                    'Free'
                  ) : (
                    <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '0.15em' }}>
                      +<PriceTag amount={option.price} currency={currency} size="sm" color="inherit" style={{ fontSize: 'inherit', fontWeight: 'inherit' }} />
                    </span>
                  )}
                </span>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AddonCategory;
